import React from "react";
import "./SocialMedia.css";
import { BsLinkedin, BsGithub } from "react-icons/bs";
import SocialMediaItem from "./SocialMediaItem";

const socialMediaData = [
  {
    href: "https://www.linkedin.com/in/muthudev",
    icon: BsLinkedin,
  },
  {
    href: "https://github.com/MuthuDev4",
    icon: BsGithub,
  },
];

const SocialMedia = () => {
  return (
    <>
      <div className="separator"></div>
      <ul className="social-list">
        {socialMediaData.map((item, index) => (
          <SocialMediaItem
            key={index}
            href={item.href}
            icon={item.icon}
          />
        ))}
      </ul>
    </>
  );
};

export default SocialMedia;
